import {forwardRef, useEffect, useImperativeHandle} from 'react';
import {io} from 'socket.io-client';

/*type Props = {
  room: string;
  onConnect: () => void;
  onDisconnect: () => void;
  onCountChange?: (count: number) => void;
  onEvent?: (data: {reaction: string}) => void;
};*/

//const socket = io('http://192.168.15.97:5000', {
const socket = io('https://cartoonito.com.br/', {
    path: '/socket',
    autoConnect: false,
    transports: ['websocket'],
});

const SocketComponent = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        sendMessage(message) {
            socket.emit('event', {
                type: 'reaction',
                reaction: message,
                room: props.room,
            });
        },
    }));

    useEffect(() => {
        console.log('Socket start');

        socket.on('connect', () => {
            console.log('Socket connected');
            props.onConnect();
            //join room
            socket.emit('join', {room: props.room});
        });

        socket.on('disconnect', () => {
            console.log('Socket disconnected');
            props.onDisconnect();
        });
        socket.on('connect_error', error => {
            console.log('Socket connect_error', error);
        });

        socket.on('event', data => {
            if (data.room !== props.room) {
                return;
            }
            console.log('Socket event', data);
            if (props.onEvent) {
                props.onEvent(data);
            }
        });
        socket.on('count', data => {
            if (data.room !== props.room) {
                return;
            }
            console.log('Count event', data);
            if (props.onCountChange) {
                props.onCountChange(data.count);
            }
        });

        socket.connect();
        return () => {
            socket.off('connect');
            socket.off('disconnect');
            socket.off('connect_error');
            socket.off('event');
            socket.off('count');

            socket.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
});

export default SocketComponent;
